import Axios from "axios";
import axiosCancel from 'axios-cancel';
import { sortCaret } from "../../../_metronic/_helpers";

import React from "react";
import { Badge } from "react-bootstrap";
/* const url_categories_dev =; */
const base_ul = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/admin-auth";
axiosCancel(Axios);



export const columns = [
  {
    dataField: "last_login",
    text: "Last Login",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "name",
    text: "Firstname",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "last_name",
    text: "Lastname",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "phone",
    text: "Phone",
    sort: true,
    sortCaret: sortCaret,
  },
];

export function getClients(setCategory) {
  Axios.get(`${base_ul}/find`)
    .then((res) => {
      setCategory(res.data.payload);
    })
    .catch((err) => { });
}
export function getClient(uid = "") {
  return Axios.get(`${base_ul}/find/${uid}`);
}
export function updateClient(admin) {
  if (admin.uid) {
    return Axios.put(`${base_ul}/update/${admin.uid}`, admin);
  } else {
    return Axios.post(`${base_ul}/create`, { admin });
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${base_ul}/delete/${uid}`);
}
